import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { getAuth, deleteUser, EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";
import { getFirestore, doc, deleteDoc } from "firebase/firestore";
import firebaseApp from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import './UserView.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const auth = getAuth(firebaseApp);
const firestore = getFirestore(firebaseApp);

function UserView() {
    const [password, setPassword] = useState('');
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const userAuth = auth.currentUser;
        if (userAuth) {
            setUserEmail(userAuth.email);
        } else {
            Swal.fire('Error', 'No se encontró la sesión del usuario. Inicia sesión de nuevo.', 'error');
        }
    }, []);

    const goToHome = () => {
        navigate('/home');
    };

    const openPasswordModal = () => {
        setIsPasswordModalOpen(true);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleDeleteAccount = async () => {
        const userAuth = auth.currentUser;

        if (!userAuth) {
            Swal.fire('Error', 'No se encontró la sesión del usuario. Inicia sesión de nuevo.');
            return;
        }

        try {
            const credential = EmailAuthProvider.credential(userAuth.email, password);
            await reauthenticateWithCredential(userAuth, credential);

            const userDocRef = doc(firestore, 'usuarios', userAuth.uid);
            await deleteDoc(userDocRef);
            await deleteUser(userAuth);

            Swal.fire('Cuenta eliminada', 'Tu cuenta ha sido eliminada correctamente.')
                .then(() => {
                    setTimeout(() => {
                        navigate('/login');
                    }, 2000);
                });
        } catch (error) {
            console.error('Error al eliminar la cuenta:', error);
            if (error.code === 'auth/requires-recent-login') {
                Swal.fire('Error', 'Necesitas iniciar sesión nuevamente para eliminar tu cuenta.');
            } else {
                Swal.fire('Error', 'No se pudo eliminar la cuenta. Intenta de nuevo.');
            }
        }
    };

    const validatePassword = (password) => {
        if (!password) return "La contraseña es requerida.";
        if (password.length < 6) return "La contraseña debe tener al menos 6 caracteres.";
        return "";
    };

    return (
        <div className="containerAdmin">
            <h1 className="title">Hola, {userEmail}</h1>

            {!isPasswordModalOpen && (
                <div className="content-container">
                    <p className="subtitle">
                        Si deseas eliminar tu cuenta, da clic en el botón ELIMINAR CUENTA
                    </p>
                    <div className="button-container">
                        <button className="button deletebtn" onClick={openPasswordModal}>ELIMINAR CUENTA</button>
                        <button className="button" onClick={goToHome}>SALIR</button>
                    </div>
                </div>
            )}

            {isPasswordModalOpen && (
                <div className="password-modal">
                    <div className="modal-content">
                        <h3 className='description'>Confirma tu contraseña para eliminar la cuenta</h3>
                        <label>
                            Contraseña:
                            <div className="password-container">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={handlePasswordChange}
                                    placeholder="Ingresa tu contraseña aquí"
                                />
                                <button
                                    type="button"
                                    className="eye-button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label="Mostrar u ocultar contraseña"
                                >
                                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                </button>
                            </div>
                        </label>
                        {validatePassword(password) && <p className="error">{validatePassword(password)}</p>}
                        <div className="button-container">
                            <button className='button confirm-deletion' onClick={handleDeleteAccount}>Confirmar eliminación</button>
                            <button className='button' onClick={() => setIsPasswordModalOpen(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default UserView;
